const GeotabApi = require('mg-api-js');

export default {
    deviceName: "Nissan Leaf 2019",
   // deviceName: "Tesla Model S P85",
    //deviceName: "SEA ISUZU FSR EV",
    authentication: {
        credentials: {
            database: 'powertrip',
            userName: 'nick@littlemonkey.co.nz',
            password: 'Makeshift:Glitter:Disarm'
        },
        path: 'my.geotab.com'
    },
    cache: {
        data: {},
        status: {},
        soc: {}
    },

    authenticate() {
        const api = new GeotabApi(this.authentication);
        api.authenticate(success => {
            this.authentication = success;
        })
    },
    getCarData(name) {
        name = name || this.deviceName;
        if (name in this.cache.data) {
            return this.cache.data[name];
        }
        let cache = this.cache;
        const api = new GeotabApi(this.authentication);
        return api.call('Get', {
            typeName: 'Device',
            search: {
                name: name
            },
            resultsLimit: 1
        })
            .then(function(result) {
                cache.data[name] = result[0];
                return result[0];
            })
            .catch(error => {
                // some form of error occured with the request
                console.log(error);
            });
    },
    getDeviceStatus(id) {
        if (id in this.cache.status) {
            return this.cache.status[id];
        }
        let cache = this.cache;
        const api = new GeotabApi(this.authentication);
        return api.call('Get', {
            typeName: 'DeviceStatusInfo',
            search: {
                deviceSearch: {
                    id: id
                }
            },
            resultsLimit: 1
        })
            .then(function(result) {
               cache.status[id] = result[0];
               return result[0];
            } )
            .catch(error => {
                // some form of error occured with the request
                console.log(error);
            });
    },
    getStateOfCharge(id) {
        if (id in this.cache.soc) {
            return this.cache.soc[id];
        }
        let cache = this.cache;
        const api = new GeotabApi(this.authentication);
        return api.call('Get', {
            typeName: 'StatusData',
            search: {
                diagnosticSearch: { id: 'DiagnosticStateOfChargeId' },
                fromDate: new Date().toISOString(),
                deviceSearch: { id: id }
            },
            resultsLimit: 1
        }).then(function(result) {
            cache.soc[id] = result[0].data;
            return result[0].data;
        }
        );
    }
}